.section {
  color: var(--color-text);
  margin-top: 10%;
  text-align: center;
  width: 300px;
}

.error {
  color: var(--color-error);
}

.message {
  font-size: 1.5rem;
}
